export * from './base'

export const defaultToken = 'prod_token'
export const defaultDomain = '.member.chukouplus.com'

export const env = 'prod'
export const loginUrl = 'https://member.chukouplus.com/user/Index/login.html'
